import { Button, Dropdown, MenuProps, Tooltip } from "antd";
import { ArrowLeftOutlined, DownOutlined, TeamOutlined, UserAddOutlined, UserOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getCurrentLanguage } from "../../Helpers/RouteHelper";
import { TextService } from "../../Services/TextService";

/**
 * Opens one of the three pages that send invites for an event: to a group, to chosen members or to
 * e-mail addresses outside the register.
 */
export const SendInviteButton = (props: { event: any }) => {
    const GetText = TextService.GetText;
    const navigation = useNavigate();
    // An event for members only can't be answered by someone outside the register.
    const externalLocked = props.event.membersOnly === true;

    const items: MenuProps['items'] = [
        { key: 'sendinvitegroup', icon: <TeamOutlined />, label: GetText("SendInvite_SendInviteGroupTitle") },
        { key: 'sendinvitemember', icon: <UserOutlined />, label: GetText("SendInvite_SendInviteMemberTitle") },
        {
            key: 'sendinviteexternal', icon: <UserAddOutlined />, disabled: externalLocked,
            label: externalLocked ? <Tooltip title={GetText("SendInvite_ExternalLockedTitle")}>{GetText("SendInvite_SendInviteExternalTitle")}</Tooltip> : GetText("SendInvite_SendInviteExternalTitle")
        },
    ];

    const onClick: MenuProps['onClick'] = (e) => {
        navigation("/" + getCurrentLanguage() + "/myevents/" + props.event.eventUniqueId + "/" + e.key);
    };

    return <Dropdown menu={{ items, onClick }} trigger={["click"]} disabled={!props.event.eventUniqueId}>
        <Button type="primary">{GetText("SendInvite_Button")} <DownOutlined /></Button>
    </Dropdown>;
};

export const getInvitesPath = (eventUniqueId: string) => "/" + getCurrentLanguage() + "/myevents/" + eventUniqueId + "/invites";

/** Shown on the send pages, which are opened from the Inbjudningar page. */
export const BackToInvites = (props: { event: any }) => {
    const GetText = TextService.GetText;
    const navigation = useNavigate();

    return <div style={{ textAlign: "left" }}>
        <Button type="link" style={{ paddingLeft: 0 }} icon={<ArrowLeftOutlined />} onClick={() => navigation(getInvitesPath(props.event.eventUniqueId))}>
            {GetText("SendInvite_BackToInvites")}
        </Button>
    </div>;
};
